// @flow strict

type LinkPathProps = {
  path: string,
  language?: string,
  domain?: string,
  ignoreTrailingSlash?: boolean,
  isAbsolute?: boolean,
};

/**
 * Create path for link depending on env.
 *
 * @param {string} path - path for link
 * @param {string} language - language
 * @param {string} domain - domain (for absolute URLs)
 * @param {boolean} ignoreTrailingSlash - set to true to create links without trailing slash
 * @param {boolean} isAbsolute - make url absolute if true
 *
 * @returns {string}
 */
export const createLinkPath = ({
  path,
  language,
  domain,
  ignoreTrailingSlash,
  isAbsolute = false,
}: LinkPathProps) => {
  // get relative path (remove slash)
  const relPath = path?.indexOf('/') === 0 ? path.substring(1) : path;
  let newPath = `/${relPath}`;

  if (language != null) {
    newPath = `${language !== 'en' ? `/${language}` : ''}/${relPath}`;
  }

  // add trailing slash if is missing
  if (ignoreTrailingSlash !== true && newPath[newPath.length - 1] !== '/') {
    newPath += '/';
  }

  // do not return URLs with domains in dev mode
  if (isAbsolute === false && process.env.NODE_ENV === 'development') {
    return newPath;
  }

  // add domain to URL if passed,
  // otherwise URL is absolute in current domain context
  return `${domain != null ? domain : ''}${newPath}`;
};
